/**
 * Default legal document URLs per brand (ADR-088) — the PACKAGE-level
 * fallback only. The actual source of truth for the URL is
 * `Brand.legalConfig` (`{termsUrl, privacyUrl}`, backend `brands` table,
 * spec AC B) — this package has no DB access and can't read it. These
 * constants exist for:
 *   - the `Brand.legalConfig = NULL` fallback (spec AC B, M10) — mirrors the
 *     exact values `seed-brands.ts` / the `AddLegalConfigToBrands` migration
 *     seed for both existing brands, so they never disagree;
 *   - `resolvePendingFromCache`'s returned `PendingDoc.url` (this package's
 *     own pure/zero-DB comparator).
 *
 * `hotelb2b` resolves to its OWN app domain (`app.hotelb2b.kukla.tech`), not
 * `kiedynabory.pl` — a HotelB2B legal document must never resolve to a
 * KiedyNabory-branded host (the exact cross-brand leak ADR-088 closes).
 */
import { BrandSlug } from './brand';
import { LegalDocumentType } from './version-history';

export const LEGAL_DOCUMENT_URLS_BY_BRAND: Record<
  BrandSlug,
  Record<LegalDocumentType, string>
> = {
  kiedynabory: {
    terms: 'https://kiedynabory.pl/regulamin/',
    privacy: 'https://kiedynabory.pl/polityka-prywatnosci/',
  },
  hotelb2b: {
    terms: 'https://app.hotelb2b.kukla.tech/hotelb2b-regulamin',
    privacy: 'https://app.hotelb2b.kukla.tech/hotelb2b-polityka-prywatnosci',
  },
};

/**
 * @deprecated Pre-ADR-088 single-brand shape. Equals
 * `LEGAL_DOCUMENT_URLS_BY_BRAND.kiedynabory` — use
 * `getLegalContent(brand).urls` instead.
 */
export const LEGAL_DOCUMENT_URLS: Record<LegalDocumentType, string> =
  LEGAL_DOCUMENT_URLS_BY_BRAND.kiedynabory;
